import { Component, OnInit } from '@angular/core';
import { ProposalService} from '../services/proposal.service'
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-proposallist',
  templateUrl: './proposallist.component.html',
  styleUrls: ['./proposallist.component.scss']
})
export class ProposallistComponent implements OnInit {
  partInfoIds: number[];
  constructor(private proposalService : ProposalService, private router: Router) { }

  ngOnInit() {
    this.proposalService.partInfoIds.subscribe(ids => this.partInfoIds = ids);
  }

  createProposal()
  {
    this.router.navigate(['../', 'proposal']);
  }

}
